import AppForm from "../app-components/Form/AppForm";

var _moment = require('moment');

var userLanguage = document.documentElement.lang;

//form for creating only
Vue.component('form-employee-with-contract', {
    mixins: [AppForm],
    props: {
        'mymcdSync': {
            //type: Array,
            required: true,
            default: function(){
                return false;
            },
        },
    },
    data: function() {
        return {
            form: {

            },
            tabsErrors: {
                employeeForm: false,
                contractForm: false,
                addressesForm: false,
                attendanceForm: false,
                mymcdForm: false
            },
            hasRangeError: null,
            checkWagePersonalNumberTimeout: null,
            mutableMymcdSync: this.mymcdSync,
        }
    },

    methods: {
        preventSubmit(event) {
            if (event) event.preventDefault();
            if (event) event.stopPropagation();
        },

        getPostData() {

            const employeeForm = this.$refs.employee_form.getPostData();
            const contractsPostdata = this.$refs.contract_form.getPostData();
            const permanentAddressForm = this.$refs.permanent_address_form.getData();
            const temporaryAddressForm = this.$refs.temporary_address_form.getData();
            const attendanceForm = this.$refs.attendance_form.getData();
            const mymcdForm = this.$refs.mymcd_form ? this.$refs.mymcd_form.getData() : null;

            employeeForm.contracts = contractsPostdata;
            employeeForm.permanent_address = permanentAddressForm;
            employeeForm.temporary_address = temporaryAddressForm;
            employeeForm.attendance_data = attendanceForm;

            if(mymcdForm !== null) {
                employeeForm.mymcd_sync = mymcdForm.mymcd_sync
            }

            return employeeForm;
        },

        onSubmit(submitType) {
            this.submiting = true;
            this.hasRangeError = null;

            return Promise.all([
                       this.$refs.employee_form.$validator.validateAll(),
                       this.$refs.contract_form.validatorValidateAllContracts(),
                       this.$refs.permanent_address_form.$validator.validateAll(),
                       this.$refs.temporary_address_form.$validator.validateAll()
                   ]).then((responseArr) => {
                       if (!responseArr[0] || !responseArr[1] || !responseArr[2] || !responseArr[3]) {
                            this.tabsErrors.employeeForm = !responseArr[0];
                            this.tabsErrors.contractForm = !responseArr[1];
                            this.tabsErrors.addressesForm = (!responseArr[2] || !responseArr[3]);

                            if(this.$refs.contract_form.$validator.errors.items.some(error => error.rule === 'contract_range')) {
                                const overlapingContracts = this.$refs.contract_form.getOverlapingContracts();
                                this.hasRangeError = overlapingContracts.join('  ⇿  ');
                            }

                            this.$notify({ type: 'error', title: this.trans.errors.title, text: this.trans.errors.form_contains_errors });
                            this.submiting = false;
                            return false;
                       } else {
                            axios.post(this.action, this.getPostData()).then((response) => {
                                return this.onSuccess(response.data, submitType);
                            }).catch((errors) => {
                                if(errors.response.status !== 422) { // only on diff response codes, because 422 is handled later in this.onFail processing
                                    this.$notify({ type: 'error', title: this.trans.errors.title, text: this.trans.errors.server_error });
                                }
                                return this.onFail(errors.response.data.errors);
                            }).finally(() => {
                                this.submiting = false;
                            });
                            return true;
                       }
                    });
        },

        onSuccess(data, submitType) {
            this.submiting = false;

            this.$notify({ type: 'success', title: '<span class="fa fa-check"></span>', text: data.message });

            if(submitType == 'save' && this.action != "add") {
                window.location.reload();
            } else if(submitType == 'save_close' && this.action == "add") {
                window.location.href = data.redirect_default;
            } else {
                window.location.href = data.redirect;
            }
        },

        onFail: function onFail(errors) {
            this.submiting = false;
            //var bag = this.$validator.errors;
            var employeeBag = this.$refs.employee_form.$validator.errors;
            var contractBag = this.$refs.contract_form.$validator.errors;
            employeeBag.clear();
            contractBag.clear();
            Object.keys(errors).map(function (key) {
                if (key.indexOf('contracts.')>=0) {
                    var newKey = key.replace('contracts.0.', '').replace('salary_addition.0.', '');
                    contractBag.add({ field: newKey, msg: errors[key][0] });
                } else {
                    employeeBag.add({ field: key, msg: errors[key][0] });
                }
            });

            this.$notify({ type: 'error', title: this.trans.errors.title, text: this.trans.errors.form_contains_errors });
        },

        closeWindow(event) {
            if(history.previous || history.length > 1) {
                event.preventDefault();
                history.go(-1);
            }
            else if(window.opener){
                event.preventDefault();
                window.close();
            }
        },

        showDisableSyncEmployeeModal() {
            this.$modal.show('disable-sync-employee-modal');
        },

        updateMymcdSync(newValue) {
            this.mutableMymcdSync = newValue;
        },
    }
});



// WEBPACK FOOTER //
// ./resources/assets/admin/js/employee/FormEmployeeWithContract.js